export interface Sort {
  field: string;
  direction: SortDirection;
}

export enum SortDirection {
  ASC = '0',
  DESC = '1',
}
